export default __webpack_public_path__ + "static/media/menu.9f39c251.svg";